<div class="notes-card">
  <div class="doc-insidecard">
    <div class="category-activity-header">
      <wm-common-text [data]="{ text: 'Notes' }"></wm-common-text>
    </div>

    <div *ngIf="isLoading" class="loader">
      <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
    </div>

    <ng-container *ngIf="!isLoading && applicationId">

      <app-common-notes
        [applicationId]="applicationId"
        [applicationNumber]="applicationNumber"
      >
      </app-common-notes>

    </ng-container>

    <ng-container *ngIf="!isLoading && !applicationId">
      <div class="no-data-wrapper">
        <wm-common-text
          class="no-data-text"
          [data]="{ text: 'No Notes Available' }"
        >
        </wm-common-text>
      </div>
    </ng-container>

  </div>
</div>